export type LocalUserId = string;

export interface LocalUserState {
  name: string;
  attendeeId: string;
  rosterId: string;
  muted: boolean;
  cameraOn: boolean;
  volume: number | null;
  tileId: number;
  contentTileId: number;
}

export type Roster = Record<LocalUserId, LocalUserState>;

export const getBlankState = (): LocalUserState => ({
  name: "",
  attendeeId: "",
  rosterId: "",
  muted: false,
  cameraOn: true,
  tileId: 0,
  contentTileId: 0,
  volume: null
});

export const RosterKey = Symbol();
